// extracted by mini-css-extract-plugin
export default {"cardHeader":"styles_cardHeader__d5Gr3","cardHeaderContainer":"styles_cardHeaderContainer__ms8U4","cardContent":"styles_cardContent__nzW1v"};